import { render, staticRenderFns } from "./HoldingStock.vue?vue&type=template&id=198cdc9f&scoped=true"
import script from "./HoldingStock.vue?vue&type=script&lang=js"
export * from "./HoldingStock.vue?vue&type=script&lang=js"
import style0 from "./HoldingStock.vue?vue&type=style&index=0&id=198cdc9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198cdc9f",
  null
  
)

export default component.exports